import {Component, inject, OnInit} from '@angular/core'
import {DisclaimerComponent} from '../disclaimer/disclaimer.component'
import {DocumentComponent} from '../info/document.component'
import {RouterOutlet} from '@angular/router'
import {DocumentService} from '../../services/document.service'

@Component({
  selector: 'spb-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  imports: [
    DisclaimerComponent,
    DocumentComponent,
    RouterOutlet
  ]
})
export class HomeComponent implements OnInit {
  private readonly service = inject(DocumentService)

  public ngOnInit() {
    this.service.getDocuments().subscribe()
  }
}
